import Svg from "../svg/Svg";

interface Props {
  text?: string,
  mainClass?: string,
  onClick?: () => any
}

const EditButton = ({ mainClass, text, onClick }: Props) => {
  return <button className={"tfm fm-o-edit-button" + (mainClass ? ' ' + mainClass : '')} onClick={onClick}>
    <Svg iconPath="#edit" viewBoxWidth={22} viewBoxHeight={23} width={16} height={16} />
    <div>{text}</div>
  </button>
}

export default EditButton;